import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Typography, Button,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Link, Prompt } from 'react-router-dom';
import { getTranslate, Translate } from 'react-localize-redux';

import { BackIcon } from '../icons';

const styles = theme => ({
    root: {
        minHeight: 70,
        background: theme.colors.grey2,
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2, 4),
        display: 'flex',
        alignItems: 'center',
    },
    mainTitle: {
        flex: '1 1 auto',
    },
    button: {
        marginLeft: theme.spacing(2),
        '@media print': {
            display: 'none',
        },
    },
    backLink: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(2),

        '@media print': {
            display: 'none',
        },
    },
    underline: {
        lineHeight: '1.2rem',
        borderBottom: theme.borders.normal,
        borderBottomColor: theme.colors.blue4,
    },
    backIcon: {
        marginRight: theme.spacing(1),
    },
});

class TopActionBar extends React.Component {
    clickBack = () => {
        if (this.props.backLink?.navigateBack) {
            window.history.back();
        }
    }

    render() {
        const {
            translate, classes, title, onSave, saveEnabled, linkAction, linkActionText, studentData, backLink,
        } = this.props;

        return (
            <div className={classes.root}>
                <Prompt
                    when={onSave && saveEnabled}
                    message={translate('shared.navigateAwayUnsaved')}
                />

                <div className={classes.mainTitle}>
                    <Typography variant="h5">
                        {studentData ? studentData.name : title}
                    </Typography>
                    {studentData?.extendedProperties && studentData?.extendedProperties.class && (
                        <Typography variant="subtitle1">
                            <Translate id="student.class" />
                            {` ${studentData?.extendedProperties.class}`}
                        </Typography>
                    )}
                </div>

                {linkAction && (
                    <Button
                        className={classes.button}
                        component={Link}
                        to={linkAction}
                        color="primary"
                        variant="outlined"
                    >
                        {linkActionText}
                    </Button>
                )}
                {backLink && (
                    <Link to={backLink.to || '#'} onClick={this.clickBack}>
                        <Typography variant="caption" className={classes.backLink} color="secondary">
                            <BackIcon className={classes.backIcon} color="secondary" />
                            <span className={classes.underline}>{backLink.text}</span>
                        </Typography>
                    </Link>
                )}
                {onSave && saveEnabled && (
                    <Button
                        className={classes.button}
                        color="primary"
                        variant="contained"
                        onClick={onSave}
                    >
                        <Translate id="common.save" />
                    </Button>
                )}
            </div>
        );
    }
}

TopActionBar.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    title: PropTypes.string,
    saveEnabled: PropTypes.bool,
    linkAction: PropTypes.string,
    linkActionText: PropTypes.string,
    studentData: PropTypes.object,
    backLink: PropTypes.object,
};

TopActionBar.defaultProps = {
    onSave: null,
    title: null,
    saveEnabled: true,
    linkAction: null,
    linkActionText: null,
    studentData: null,
    backLink: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(TopActionBar));
